import { ElementRef, Injectable } from '@angular/core';
import Debug from 'debug';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
const debug = Debug('aumico:aumico-lib-core-fe:ActionFooterService');
@Injectable()
export class ActionFooterService {
    public pagingActionBar$: BehaviorSubject<ElementRef | null> = new BehaviorSubject(null);

    constructor() {
        this.pagingActionBar$
            .pipe(
                tap((data) => {
                    debug('movePagerToGlobalView', data);
                }),
            )
            .subscribe();
    }
}
